import React, { useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import UserShapefileShapeList from './UserShapefileShapeList'
import UserShapefileLevelListSelect from './UserShapefileLevelListSelect'
import classnames from 'classnames'
import Toggle from 'components/common/Toggle'
import { checkboxIcon } from '../../../utils'
import { withTranslation } from 'react-i18next'

const UserShapefileLevelList = ({
  uiStore,
  selectionStore,
  userShapefileList,
  shapefile,
  t
}) => {
  useEffect(() => {
    if (shapefile && shapefile.selectedLevel && !shapefile.selectedLevel.loaded && !shapefile.selectedLevel.loading) {
      shapefile.selectedLevel.load()
    }
  }, [shapefile, shapefile && shapefile.selectedLevelIndex])

  if (!shapefile) return null

  const selectedLevel = shapefile.selectedLevel
  const shapes = (selectedLevel && selectedLevel.shapes) || []

  return (
    <div className='shape-level-pane'>
      {/* Header Breadcrumb */}
      <div className='shape-level-pane__header'>
        <button
          type='button'
          className='shape-level-pane__back-btn'
          onClick={() => {
            userShapefileList.selectedFile = null
          }}
        >
          <svg
            width='14'
            height='14'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth='2.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <polyline points='15 18 9 12 15 6' />
          </svg>
          <span>{t('GLOBAL.BACK', { defaultValue: 'Back' })}</span>
        </button>
        <span className='shape-level-pane__divider'>/</span>
        <span className='shape-level-pane__crumb'>
          {userShapefileList.editMode
            ? t('ITEM.MY_SHAPEFILE', { defaultValue: 'My Shapefiles' })
            : t('ITEM.MY_SHAPEFILES', { defaultValue: 'My Shapefiles' })}
        </span>
      </div>

      {/* File Title & Subtitle */}
      <div className='shape-level-pane__title-wrap'>
        <h2 className='shape-level-pane__title'>{shapefile.displayName}</h2>
        <p className='shape-level-pane__subtitle'>
          {t('GLOBAL.CHOOSE_SHAPES_SUBTITLE', {
            defaultValue: 'Choose Shapes to add them to current selected Target Group'
          })}
        </p>
      </div>

      {/* Multi-level dataset select if any */}
      {shapefile.levels && shapefile.levels.length > 1 && (
        <div style={{ marginBottom: 12 }}>
          <UserShapefileLevelListSelect shapefile={shapefile} />
        </div>
      )}

      {/* Select All Row */}
      <div
        className={classnames('shape-level-pane__select-all', {
          disabled: shapefile.willExceededLimit
        })}
      >
        <span className='shape-level-pane__select-all-label'>
          {t('GLOBAL.SELECT_ALL', { defaultValue: 'Select All' })}
        </span>
        <Toggle
          icon={checkboxIcon(shapefile.allSelected)}
          enabled={shapefile.allSelected}
          onClick={async () => {
            if (shapefile.allSelected) {
              shapefile.deselectAll()
            } else {
              shapefile.selectAll()
              if (shapefile.selectedLevel) {
                await shapefile.selectedLevel.loadAll()
              }
            }
          }}
        />
      </div>

      {/* Shapes List */}
      <div className='shape-level-pane__list-wrap'>
        {selectedLevel && selectedLevel.loading
          ? (
            <div className='shape-file-pane__loading'>
              <div className='shape-file-pane__spinner' />
              <span>{t('GLOBAL.LOADING', { defaultValue: 'Loading shapes...' })}</span>
            </div>
            )
          : shapes.length === 0
            ? (
              <div className='shape-file-pane__empty'>
                <span>{t('GLOBAL.NO_SHAPES_FOUND', { defaultValue: 'No shapes found in this shapefile' })}</span>
              </div>
              )
            : (
              <div className='shape-level-pane__list'>
                <UserShapefileShapeList
                  level={selectedLevel}
                  shapefile={shapefile}
                  userShapefileList={userShapefileList}
                />
              </div>
              )}
      </div>

      {/* Area / polygon validation error if any */}
      {!uiStore.areMultipolygonsValid && (
        <div className='shape-file-pane__error'>
          {t('ITEM.MULTI_POLYGON_TOO_LARGE', { defaultValue: 'Multipolygon area is too large.' })}
        </div>
      )}

      {/* Footer / Add Action */}
      <div className='shape-level-pane__footer'>
        <button
          type='button'
          className='shape-level-pane__btn-add'
          disabled={shapefile.selectedCount <= 0}
          onClick={async (e) => {
            e.preventDefault()
            if (selectionStore.data && selectionStore.data.group) {
              await uiStore.addUserShapefileShapes(
                selectionStore.data.group,
                shapefile
              )
            } else {
              userShapefileList.selectedFile = null
            }
          }}
        >
          <span>{t('GLOBAL.ADD', { defaultValue: 'Add' })}</span>
        </button>
      </div>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore')(observer(UserShapefileLevelList)))
